function staRequest (point) {
  return axios({
      url: '/api/activity/statistic',
      method: 'post',
      data:{
          activity_id:3,
          point
      },
      transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
      }]
  })
}


new Vue({
  el: '#app',
  components: {
    'paginate': VuejsPaginate,
  },
  data: {
    actWorkShow: false,
    changeTxt: '查看',
    theResult:true,
    overTime:false,
    popClose: true,
    subClose: true,
    coverClose: true,
    mySwiper: '',
    videoAutoplay:'',
    videoOpen: false,
    videoSrc: '',
    iframeSrc: '',
    actTime1: false,
    actTime2: false,
    actTime3: false,
    actTime4: false,
    bgVideoPlay: true,
    submitClose:false,
    SuccessClose:true,
    QAClose:true,
    message:'',
    slideList:[],
    res: [],
    download: '',
    wxQrCode:false,
    QrCode: false,
    toastShow: false,
    toastTxt: '',
    paginateShow:false,
    params:{
      title:'',
      city:'',
      order: 'like',
      p:1
    },
    subParams:{
      url	:'',
      city:''
    },
    total_pages:'',
    listVideo: [],
    selectedOrder:'like',
    orderSelectList:[
      {
        id:0,
        value:'like',
        label:'按热度'
      },
      {
        id:1,
        value:'time',
        label:'按时间'
      }
    ],
    selectedCity:'',
    citySelectList:[
      {
        id:0,
        value:'深圳',
        label:'深圳'
      },
      {
        id:1,
        value:'北京',
        label:'北京'
      },
      {
        id:2,
        value:'上海',
        label:'上海'
      },
      {
        id:3,
        value:'广州',
        label:'广州'
      },
      {
        id:4,
        value:'杭州',
        label:'杭州'
      },
      {
        id:5,
        value:'成都',
        label:'成都'
      },
      {
        id:6,
        value:'西安',
        label:'西安'
      },
      {
        id:7,
        value:'武汉',
        label:'武汉'
      },
      {
        id:8,
        value:'其他城市',
        label:'其他城市'
      },
    ],
    searchCitySelectList:[
      {
        id:0,
        value:'',
        label:'全部'
      },
      {
        id:1,
        value:'深圳',
        label:'深圳'
      },
      {
        id:2,
        value:'北京',
        label:'北京'
      },
      {
        id:3,
        value:'上海',
        label:'上海'
      },
      {
        id:4,
        value:'广州',
        label:'广州'
      },
      {
        id:5,
        value:'杭州',
        label:'杭州'
      },
      {
        id:6,
        value:'成都',
        label:'成都'
      },
      {
        id:7,
        value:'西安',
        label:'西安'
      },
      {
        id:8,
        value:'武汉',
        label:'武汉'
      },
      {
        id:9,
        value:'其他城市',
        label:'其他城市'
      },
    ],
    
  },
  computed: {

  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.request();
      this.requestVideos(this.params)
      this.bgVideo()
      this.staRequest('uv_main_pc')
    },
    staRequest (point) {
      return staRequest(point)
    },
    clickDownload(){
      this.staRequest('download_click_pc')
    },
    bgVideo(){
      if (this.bgVideoPlay == true) {
        document.getElementById('bgVideo').load();
        document.getElementById('bgVideo').play();
      }
      else{
        document.getElementById('bgVideo').pause();
      }
    },
    swiperInit(){
      this.mySwiper = new Swiper('.swiper-container', {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        spaceBetween : 10,
        slidesPerView: 3,//一行显示3个
        slidesPerColumn: 2,//显示2行
        slidesPerColumnFill : 'column',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    },
    request() {
      axios({
        url: '/api/city-story/status',
        method: 'get',
      }).then(resp => {
        const highterSet = []
        let count = 0
        this.res = resp
        // 列表赋值
        this.slideList = resp.data.data.sample_videos
        this.timePross()
        // 将highter为ture的idx值存到一个set
        this.slideList.forEach((item,idx) => { 
          if(item.higher){
            count ++
            highterSet.push(idx + count)
          }
        })
        
        // 往higher后加一个占位符项
        for(let i = 0; i < highterSet.length; i++){
          this.slideList.splice(highterSet[i], 0, {
            thumb: "",
            app_thumb: "",
            url: "",
            city: "placeholder"
          })
        }
        this.$nextTick(() => {
          this.swiperInit()
        })
      }).catch(err => {
        console.log('err', err)
      })
    },
    slideCls(cls, city){
      return `${cls}-${city}`
    },
    timePross() {
      if (this.res.data.data.phase === 1) {
        this.actTime1 = true;
      } else if (this.res.data.data.phase === 2) {
        this.actTime1 = true;
        this.actTime2 = true;
      } else if (this.res.data.data.phase === 3) {
        this.actTime1 = true;
        this.actTime2 = true;
        this.actTime3 = true;
        this.overTime = true;
      } else if (this.res.data.data.phase === 4) {
        this.actTime1 = true;
        this.actTime2 = true;
        this.actTime3 = true;
        this.actTime4 = true;
        this.overTime = true;
        this.theResult = true;
      }
    },
    videoOn(type, src) {
      // if (v === 1) {
      //   this.videoScr = '//player.bilibili.com/player.html?aid=48985782&cid=85784985&page=1';
      //   // this.videoScr = this.res.data.data.sample_videos[v].url;
      // }
      // this.scrollLock();
      // this.videoOpen = true;
      // this.coverClose = false;
      // var videosPlay = document.getElementById('video');
      // videosPlay.play();
      // $('html').addClass('noscroll');
      // // $.smartScroll($('#videoOpen'), '.scrollable');
      let videosPlay = null
      
      if (type === 1) {
        this.videoSrc = src
      }else if (type === 2){
        this.iframeSrc = src
      }

      if(src !== ''){
        this.scrollLock();
        this.videoOpen = true;
        this.coverClose = false;
        this.QrCode = false;
        this.download = false;
        this.bgVideoPlay = false;
        this.bgVideo()
        $('html').addClass('noscroll');
      }else{
        this.toast('目前暂时还没有上线特邀作品，敬请期待~')
      }

      videosPlay = document.getElementById('video');
      if(videosPlay){
        videosPlay.play();
      }
      
    },
    toast(txt){
      let timer;
      this.toastTxt = txt
      if(this.toastShow){
        return;
      }else{
        this.toastShow = true;
        timer = setTimeout(() => {
          this.toastShow = false
        }, 2800)
      }
    },
    scrollLock() {
      $('.container').bind('touchmove', function (e) {
        e.preventDefault() && e.preventDefault;
      });
    },
    scrollUnLock() {
      $('.container').unbind();
    },
    videoOff() {
      this.coverClose = true;
      this.videoOpen = false;
      this.download = true;
      this.bgVideoPlay = true;
      this.bgVideo()
      this.videoSrc = '';
      this.iframeSrc = '';
      this.scrollUnLock();
      $('html').removeClass('noscroll');

    },
    openPop() {
      this.popClose = false;
      this.coverClose = false;
      this.download = true;
      $('html').addClass('noscroll');
      $.smartScroll($('#pop-ups'), '.scrollable');
    },
    closePop() {
      this.popClose = true;
      this.coverClose = true;
      this.submitClose = false;
      this.SuccessClose = true;
      this.QAClose = true;
      this.subClose = true;
      $('html').removeClass('noscroll');
    },
    openSUb() {
      if(this.overTime === true){
        return
      }
      this.subClose = false;
      this.coverClose = false;
      $('html').addClass('noscroll');
      $.smartScroll($('sub-ups'), '.scrollable');
    },
    closeSub() {
      this.submitClose = false;
      this.SuccessClose = true;
      this.QAClose = true;
      this.subClose = true;
      this.coverClose = true;
      this.subParams.city = ''
      this.subParams.url = ''
      $('html').removeClass('noscroll');
    },
    toQrcode() {
      if (this.wxQrCode === true) {
        this.wxQrCode = false;
      } else {
        this.wxQrCode = true;
      }
    },
    toWxQrcode() {
      this.QrCode = true;
    },
    toQqQrcode() {
      this.QrCode = false;
    },
    requestVideos(datas) {
      axios({
        url: '/api/city-story/videos',
        method: 'get',
        params: datas
      }).then(resp => {
        this.res = resp
        this.listVideo = this.res.data.data.videos;
        this.total_pages = this.res.data.data.total_pages;
        if(this.total_pages > 1 ){
          this.paginateShow = true;
        }
        else{
          this.paginateShow = false;
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    //请求视频资源开始
     //按城市
    getVideosCity(v) {
      this.selectedCity = v;
      this.params.city = v;
      this.params.p = 1;
      this.$refs.paginate.selected = 0
      this.requestVideos(this.params)
    },
     //按热度
    getVideosOrder(v){
      this.selectedOrder = v
      this.params.order = v
      this.requestVideos(this.params)
    },
    //按搜索
    getVideosSearch(){
      this.requestVideos(this.params)
    },
    //分页
    clickCallback: function (pageNum) {
      this.params.p = pageNum;
      this.requestVideos(this.params)
   
    },
    //请求视频资源结束

    //点赞开始
    getZan(item) {
      axios({
        url: '/api/city-story/like',
        method: 'post',
        data:{
          id:item.id
        },
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
      }]
      }).then(resp => {
        if(resp.data.code !== 0){
          this.toast(resp.data.message)
        }
        else{
          item.like_cnt = `${parseInt(item.like_cnt) + 1}`
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    //点赞结束

    //提交作品开始
    subWork(){
      let pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
      if(this.subParams.url === '' && this.subParams.city === '' )
      {
        this.toast('请输入作品网址和选择城市~')
        return;
      }else if(this.subParams.url === ''){
        this.toast('请输入作品网址~')
        return;
      }
      if(pattern.test(this.subParams.url)){
        this.subParams.url = encodeURIComponent(this.subParams.url)
      }else{
        this.toast('请输入完整且正确的作品地址链接')
        return;
      }
      if(this.subParams.city === ''){
        this.toast('请选择城市~')
        return;
      }
      axios({
        url: '/api/city-story/video',
        method: 'post',
        data: this.subParams,
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
      }]
      }).then(resp => {
        if(resp.data.code === 0)
        {
          this.submitClose = true
          this.SuccessClose = false
          this.subParams.city = ''
          this.subParams.url = ''
        }
        else 
        {
          this.submitClose = true
          this.QAClose = false
          this.message = resp.data.message
          this.subParams.city = ''
          this.subParams.url = ''
        }
      }).catch(err => {
        console.log('err', err)
      })

    },
    //提交作品结束
      //奖励公布页开始
      changeResult(){
        this.actWorkShow = !this.actWorkShow;
        this.changeTxt = this.actWorkShow ? '隐藏' : '查看'
      }
      //奖励公布页结束
  }
});

